var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14,388.1L14,388.1L14,388.1c5.9,5.8,13.7,9,21.9,9s16-3.2,21.8-9l0,0l0,0L256,189.4l198.1,198.7 c5.8,5.9,13.6,9.1,21.9,9.1s16-3.2,21.9-9.1c5.9-5.8,9.1-13.5,9.1-21.7c0-8.3-3.2-16.1-9.1-22L277.8,123.9 c-5.8-5.9-13.6-9.2-21.9-9.2c-8.2,0-16,3.2-21.8,9L14,344.3c-5.8,5.8-9,13.6-9,21.8C5,374.5,8.2,382.3,14,388.1z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHigh);
export default __webpack_public_path__ + "static/media/high.d044c994.svg";
export { ForwardRef as ReactComponent };